// Module
var code = "<h2 class=\"interiorSectionHeading\"> Eligibility </h2> <p>You may qualify if:</p> <ul> <li> You, the borrower, die, then your loans may be discharged.</li> <li> You are a parent PLUS loan borrower, then your loan may be discharged if you die, or if the student on whose behalf you obtain the loan dies.</li> </ul> ";
// Exports
export default code;